import styled from '@emotion/styled';
import React from 'react';
import { messages } from '../../messages';

type PageHeaderSubtitle = {
  readonly edition: string;
  readonly useDarkBackgroundMode: boolean;
};

export function PageHeaderSubtitle({
  edition,
  useDarkBackgroundMode
}: PageHeaderSubtitle) {
  switch (edition) {
    case 'standard':
      return (
        <PageHeaderSubtitleText useDarkBackgroundMode={useDarkBackgroundMode}>
          {messages.cloudStandard.defaultMessage}
        </PageHeaderSubtitleText>
      );
    case 'premium':
      return (
        <PageHeaderSubtitleText useDarkBackgroundMode={useDarkBackgroundMode}>
          {messages.cloudPremium.defaultMessage}
        </PageHeaderSubtitleText>
      );
    default:
      return (
        <PageHeaderSubtitleText useDarkBackgroundMode={useDarkBackgroundMode}>
          {messages.cloudFree.defaultMessage}
        </PageHeaderSubtitleText>
      );
  }
}

const PageHeaderSubtitleText = styled.h4<{ useDarkBackgroundMode: boolean }>`
  margin: 0px;
  font-size: 20px;
  font-weight: 400;
  color: ${(props) =>
    props.useDarkBackgroundMode ? 'rgba(13, 20, 36, 0.97)' : 'white'};
`;
